module.exports = __webpack_public_path__ + "img/icon-shield-crossed.30075a29.svg";